import Axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const GenreAcc = ({ genre }) => {
    const [competitions, setCompetitions] = useState([]);

    const fetchCompetitions = () => {
        Axios.get(
            `https://ashish.moodi.org/competitions/get_genre_compi?genre=${genre.genreId}`
        ).then((res) => setCompetitions(res.data));
    };

    useEffect(() => {
        fetchCompetitions();
        // eslint-disable-next-line
    }, []);
    return (
        <div class="accordion-item">
            <h2 class="accordion-header">
                <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#${genre.genreId}`}
                    aria-expanded="true"
                    aria-controls={genre.genreId}
                >
                    {genre.genreName}
                </button>
            </h2>
            <div
                id={genre.genreId}
                class="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
            >
                <div class="accordion-body">
                    <ul>
                        {competitions.map((competition) => {
                            return (
                                <li>
                                    <Link
                                        to={`/admin/competitions/competition/${competition.competitionId}`}
                                    >
                                        {competition.competitionName}{" "}
                                        {competition.isTeamCompi
                                            ? "(Team)"
                                            : ""}
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default GenreAcc;
